import { z } from 'zod';
import { adminAiWindowQuerySchema } from './ai-ops.js';
import { cursorPageQuerySchema } from './pagination.js';
export const AI_RATING_SURFACES = ['coach_message', 'weekly_review'];
export const AI_RATING_REASONS = [
    'inaccurate',
    'did_not_answer',
    'wrong_plan_change',
    'tone',
    'wrong_language',
    'wrong_numbers',
    'generic',
];
export const WEEKLY_REVIEW_PROSE_SOURCES = ['model', 'fallback', 'no_ai_consent'];
export const adminAiRatingTallySchema = z.object({
    rated: z.number().int(),
    up: z.number().int(),
    down: z.number().int(),
});
const ratingsByModelSchema = adminAiRatingTallySchema.extend({ model: z.string() });
const surfaceFields = {
    exposures: z.number().int(),
    ...adminAiRatingTallySchema.shape,
    approvalRate: z.number().nullable(),
    ratedShare: z.number().nullable(),
    byModel: z.array(ratingsByModelSchema),
    modelUnknown: adminAiRatingTallySchema,
};
export const adminAiRatingsSurfaceSchema = z.discriminatedUnion('surface', [
    z.object({ surface: z.literal('coach_message'), ...surfaceFields }),
    z.object({
        surface: z.literal('weekly_review'),
        ...surfaceFields,
        byProseSource: z.array(adminAiRatingTallySchema.extend({ proseSource: z.enum(WEEKLY_REVIEW_PROSE_SOURCES).nullable() })),
    }),
]);
export const adminAiRatingsSchema = z.object({
    windowDays: z.number().int(),
    from: z.string(),
    surfaces: z.array(adminAiRatingsSurfaceSchema),
});
export const adminAiDownRatingsQuerySchema = cursorPageQuerySchema.extend({
    days: adminAiWindowQuerySchema.shape.days,
    surface: z.enum(AI_RATING_SURFACES).optional(),
});
const downRatingFields = {
    id: z.string().uuid(),
    userId: z.string().uuid(),
    displayName: z.string().nullable(),
    phone: z.string(),
    reason: z.enum(AI_RATING_REASONS).nullable(),
    model: z.string().nullable(),
    ratedAt: z.string(),
};
export const adminAiDownRatingSchema = z.discriminatedUnion('surface', [
    z.object({
        surface: z.literal('coach_message'),
        ...downRatingFields,
        sessionId: z.string().uuid().nullable(),
    }),
    z.object({
        surface: z.literal('weekly_review'),
        ...downRatingFields,
        weekStart: z.string().nullable(),
        proseSource: z.enum(WEEKLY_REVIEW_PROSE_SOURCES).nullable(),
    }),
]);
//# sourceMappingURL=ai-ratings.js.map